import React,{Fragment, Component} from 'react';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import PageTitle from '../Layout/PageTitle';
import {EducationBanner} from './Index1';
import TeacherSlider from '../Element/TeacherSlider';
//Images
import bnr1 from './../../images/line2.png';
import bnr2 from './../../images/line2.png';
import bnr3 from './../../images/background/bg6.png';
import CenterImg from './../../images/about/about-2.jpg';
import Children1 from './../../images/background/children1.png';
import Children2 from './../../images/background/children2.png';

const TextBlog =({title})=>{
	return(
		<div className="icon-content">
			<h5 className="dlab-tilte">{title}</h5>
			{/* <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod..</p> */}
		</div>	
	)
}
function AcademyBlog(){
	return(
		<>
			<div className="container">
			<div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="section-head text-center">
              <h2 className="head-title text-secondry">
                Welcome To Bright Future{" "}
              </h2>
              <p>
                Welcome to BrightFuture School, where we nurture young minds
                from Playgroup, Nursery, Jr. KG, Sr. KG, and Grade 1 to 5 in
                English and Gujarati medium, blending learning with fun. Our
                holistic approach ensures a strong foundation for academic
                excellence and overall growth.
              </p>
            </div>
          </div>
        </div>
		<div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="icon-bx-wraper right m-b30 about-iconbx">
              {/* <div className="icon-bx-sm radius bg-pink">
                {" "}
                <Link to={"#"} className="icon-cell">
                  <i className="flaticon-book"></i>
                </Link>{" "}
              </div> */}
              <TextBlog title="Cambridge Publication Textbooks" />
            </div>
            <div className="icon-bx-wraper right m-b30 about-iconbx">
              {/* <div className="icon-bx-sm radius bg-blue">
                {" "}
                <Link to={"#"} className="icon-cell">
                  <i className="flaticon-bus"></i>
                </Link>{" "}
              </div> */}
              <TextBlog title="School Bus" />
            </div>
            <div
              className="icon-bx-wraper right m-b30 about-iconbx"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                marginLeft: "auto",
                width: "100%",
              }}
            >
              <TextBlog title="Digital Class Room" />
              {/* <div
                className="icon-bx-sm radius bg-blue"
                style={{ marginLeft: "10px" }}
              >
                <Link to={"#"} className="icon-cell">
                  <i className="fas fa-school"></i>
                </Link>
              </div> */}
            </div>

            <div className="icon-bx-wraper right m-b30 about-iconbx">
              {/* <div className="icon-bx-sm radius bg-blue">
                {" "}
                <Link to={"#"} className="icon-cell">
                  <i className="flaticon-boy"></i>
                </Link>{" "}
              </div> */}
              <TextBlog title="Clean and child-friendly toilets" />
            </div>
			
            <div className="icon-bx-wraper right m-b30 about-iconbx">
              {/* <div className="icon-bx-sm radius bg-blue">
                {" "}
                <Link to={"#"} className="icon-cell">
                  <i className="flaticon-boy"></i>
                </Link>{" "}
              </div> */}
              <TextBlog title="Clean and child-friendly toilets" />
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 m-b30 d-md-none d-lg-block d-sm-none">
            <img src={CenterImg} alt="" />
            {/* <img src={clsimg2} alt="" />
            <img src={clsimg3} alt="" /> */}
          
          </div>
		  
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="icon-bx-wraper left m-b30 about-iconbx">
              {/* <div className="icon-bx-sm bg-green radius">
                {" "}
                <Link to={"#"} className="icon-cell">
                  <i className="flaticon-bus"></i>
                </Link>{" "}
              </div> */}
              <TextBlog title="Sports Ground (Cricket ,Basketball Court)" />
            </div>
            <div className="icon-bx-wraper left m-b30 about-iconbx">
              {/* <div className="icon-bx-sm bg-orange radius">
                <Link to={"#"} className="icon-cell">
                  <i className="flaticon-ice-cream"></i>
                </Link>{" "}
              </div> */}
              <TextBlog title="Uniforms" />
            </div>
            <div
              className="icon-bx-wraper left m-b30 about-iconbx"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                width: "100%",
                marginLeft: "0",
              }}
            >
              {/* <div
                className="icon-bx-sm radius bg-blue"
                style={{ marginRight: "10px" }}
              >
                <Link to={"#"} className="icon-cell">
                  <i className="flaticon-boy"></i>
                </Link>
              </div> */}
              <TextBlog title="Digital Class Room" />
            </div>

            <div className="icon-bx-wraper left m-b30 about-iconbx">
              {/* <div className="icon-bx-sm bg-orange radius">
                <Link to={"#"} className="icon-cell">
                  <i className="flaticon-ice-cream"></i>
                </Link>{" "}
              </div> */}
              <TextBlog title="Highly Qualified and Experienced Teacher" />
            </div>
            <div className="icon-bx-wraper left m-b30 about-iconbx">
              {/* <div className="icon-bx-sm bg-orange radius">
                <Link to={"#"} className="icon-cell">
                  <i className="flaticon-ice-cream"></i>
                </Link>{" "}
              </div> */}
              <TextBlog title="Student  Report Card" />
            </div>
          </div>
		  
        </div>
			</div>
		</>
	)
}

class AboutUs2 extends Component{
	render(){
		return(
			<Fragment>
				<Header />
				<div className="page-content">
					
					<PageTitle  motherMenu="About Us "  activeMenu="About Us " />
					
					<div className="content-block">
						{/* Section-1 */}
						<div className="section-full bg-white content-inner-1 about-kids section-bg-soft" style={{backgroundImage:"url("+ bnr1 +")"}}>
							<AcademyBlog />
							<div className="childern-box">
								<div className="childern-1"><img src={Children1} alt=""/></div>
								<div className="childern-2"><img src={Children2} alt=""/></div>
							</div>
						</div>							
						<EducationBanner />	
						
						<div className="section-full bg-white content-inner-1 section-bg-soft" style={{backgroundImage:"url("+ bnr2 +")"}}>
							<div className="container">
								<div className="section-head text-center">
									<h2 className="head-title text-secondry">About  the Teachers</h2>
									<p>We have an excellent teacher to child ratio at our Kindergarten to ensure that each child receives the attention he or she needs</p>
								</div>
								<TeacherSlider />
							</div>
						</div>
						
						<div className="section-full bg-white content-inner-2 about-content bg-img-fix" style={{backgroundImage:"url("+ bnr3 +")"}}>
							<div className="container">
								<div className="row">
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 wow fadeIn about-text" data-wow-delay="0.2s" data-wow-duration="2s" style={{visibility: "visible", animationDuration: "2s", animationDelay: "0.2s", animationName: "fadeIn"}}>
										<div className="section-head text-center">
											<h4 className="text-white">Join Our New Session</h4>
											<h2>Call To Enrol Your Child <br/><span className="text-yellow">+91 99791 95757</span></h2>
											
										</div>
									</div>
								</div>
							</div>
						</div>
					
						{/* <div className="section-full bg-white content-inner">
							<div className="container">
								<div className="section-head text-center">
									<h2 className="head-title text-secondry">From the Blog</h2>
									<p>We have an excellent teacher to child ratio at our Kindergarten to ensure that each child receives the attention he or she needs</p>
								</div>
								<FromSlider />
							</div>
						</div> */}
						{/* Section-5 End*/}
					</div>
				</div>
				<Footer />
			</Fragment>
		)
	}
}
export {AcademyBlog};
export default AboutUs2;